import { z } from 'zod';

import { schemaId } from '../utils/schema.utils';

export const schemaChatPartnerLinkedPayload = z.object({
    partnerId: schemaId,
});

export type Schema_ChatPartnerLinkedPayload = z.infer<typeof schemaChatPartnerLinkedPayload>;
